export enum LoanStatus {
  Submitted = 1,
  Processing = 2,
  NeedsInput = 3,
  Prequalified = 4,
  OfferSent = 5,
  PrequalOfferAccepted = 6,
  PrequalOfferRejected = 7,
  Approved = 8,
  DocumentsSent = 9,
  ConditionsMet = 10,
  Withdrawn = 11,
  PrequalDenied = 12,
  BankDenied = 13,
  PrequalNotAccepted = 14,
  PrequalAuctionLost = 15
}

export enum LoanType {
  PurchaseFixedAsset = 1,
  RefinanceDebt = 2,
  OperatingLoan = 3,
  DealerPurchase = 4,
  EquipmentRefinance = 5,
  GapFinancing = 6,
  ProductionLineOfCredit = 7,
  EquipmentAuctionPurchase = 8
}

export enum SubmittedPortal {
  Mobile = 1,
  Customer = 2,
  Dealer = 3
}

export enum FixedAssetType {
  Equipment = 1,
  Livestock = 2,
  RealEstate = 3,
}

export enum CollateralEquityTypes {
  CashDown = 1,
  Trade = 2,
  OtherCollateral = 3,
}

export enum LivestockCommodityType {
  Beef = 1,
  Poultry = 2,
  Pork = 3,
  Other = 4,
}

export enum CropCommodityType {
  Corn = 1,
  Hay = 2,
  Pasture = 3,
  Soybeans = 4,
  Wheat = 5,
  Other = 6,
}

export enum GrossRevenueType {
  Projected = 1,
  Prior = 2,
}

export enum ApplicantType {
  Primary = 1,
  Joint = 2,
}

export enum ScorecardLevel {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3,
}

export enum LoanAction {
  Prequalify = 1,
  RequestInput = 2,
  EditOffer = 3,
  CounterOffer = 4,
  Approve = 5,
  DocumentsSent = 6,
  ConditionsMet = 7,
  Withdraw = 8,
  PrequalDeny = 9,
  BankDeny = 10,
}

export enum LendingLoanType {
  InstallmentLoanSingleAdvance = 1,
  SinglePaySingleAdvance = 2,
  RevolvingLOCMultipleAdvance = 3,
  ClosedEndLOCMultipleAdvance = 4,
}

export enum InterestType {
  Variable = 1,
  FixedRate = 2,
}

export enum PeriodicRateIncrease {
  Immediate = 1,
  ThirtyDays = 2,
  SixtyDays = 3,
  NinetyDays = 4,
  OneHundredTwentyDays = 5,
  OneHundredEightyDays = 6,
  OneMonth = 7,
  ThreeMonths = 8,
  SixMonths = 9,
  TwelveMonths = 10,
  EighteenMonths = 11,
  TwentyFourMonths = 12,
  ThirtySixMonths = 13,
  FortyEightMonths = 14,
  SixtyMonths = 15,
}

export enum SecurityRoleEnum {
  Admin = 1,
  LoanOfficer = 2,
  Manager = 3,
  DealerSalesman = 4,
}

export enum AgriculturalProductMeasurers {
  None = 0,
  Acres = 1,
  Bale = 2,
  Bushels = 3,
  CwtPer100Pounds = 4,
  Flat = 5,
  FourFiveBushel = 6,
  Gallon = 7,
  Hogshead = 8,
  Lug = 9,
  Other = 10,
  PerAcre = 11,
  PerBoardFoot = 12,
  PerHead = 13,
  Pound = 14,
  Sacks = 15,
  ThreeFourBushel = 16,
  Tons = 17,
}

export enum DocumentRequestStatus {
  Fulfilled = 1,
  Unfulfilled = 2,
}

export enum DocumentType {
  TaxReturn = 1,
  BalanceSheet = 2,
  CashFlow = 3,
  Other = 4,
  RegB = 5,
  PhotoOfVin = 6,
  PurchaseOrderForm = 7,
  PurchasePhoto = 8,
  GovernmentContract = 9,
  BankStatement = 10,
  ProfitAndLoss = 11,
  OperatingAgreement = 12,
  BorrowingResolution = 13,
  ArticlesOfIncorporation = 14,
  UccFiling = 15,
  CreditReport = 16,
  CreditArrangement = 17
}

export const DocumentTypeMapper = {
  [Number(DocumentType.TaxReturn)]: 'Tax Return',
  [Number(DocumentType.BalanceSheet)]: 'Balance Sheet',
  [Number(DocumentType.CashFlow)]: 'Cash Flow',
  [Number(DocumentType.Other)]: 'Other',
  [Number(DocumentType.RegB)]: 'Regulation B',
  [Number(DocumentType.PhotoOfVin)]: 'Photo Of Vin/Serial',
  [Number(DocumentType.PurchaseOrderForm)]: 'Purchase Order Form',
  [Number(DocumentType.PurchasePhoto)]: 'Purchase Photo',
  [Number(DocumentType.GovernmentContract)]: 'Government Contract',
  [Number(DocumentType.BankStatement)]: 'Bank Statement',
  [Number(DocumentType.ProfitAndLoss)]: 'Profit & Loss',
  [Number(DocumentType.OperatingAgreement)]: 'Operating Agreement',
  [Number(DocumentType.BorrowingResolution)]: 'Borrowing Resolution',
  [Number(DocumentType.ArticlesOfIncorporation)]: 'Articles Of Incorporation',
  [Number(DocumentType.UccFiling)]: 'UCC Filing',
  [Number(DocumentType.CreditReport)]: 'Credit Report',
  [Number(DocumentType.CreditArrangement)]: 'Credit Arrangement'
};

export const DocumentStringTypeMapper = {
  [DocumentType.TaxReturn]: 'Tax Return',
  [DocumentType.BalanceSheet]: 'Balance Sheet',
  [DocumentType.CashFlow]: 'Cash Flow',
  [DocumentType.Other]: 'Other',
  [DocumentType.RegB]: 'Regulation B',
  [DocumentType.PhotoOfVin]: 'Transaction Details Form',
  [DocumentType.PurchaseOrderForm]: 'Purchase Order Form',
  [DocumentType.PurchasePhoto]: 'Purchase Photo',
  [DocumentType.GovernmentContract]: 'Government Contract',
  [DocumentType.BankStatement]: 'Bank Statement',
  [DocumentType.ProfitAndLoss]: 'Profit & Loss',
  [DocumentType.OperatingAgreement]: 'Operating Agreement',
  [DocumentType.BorrowingResolution]: 'Borrowing Resolution',
  [DocumentType.ArticlesOfIncorporation]: 'Articles Of Incorporation',
  [DocumentType.UccFiling]: 'UCC Filing',
  [DocumentType.CreditReport]: 'Credit Report',
  [DocumentType.CreditArrangement]: 'Credit Arrangement'
};

export enum BalanceSheetAssetCategories {
  CashAndEquivalents = 1,
  MarketableBondsAndSecurities = 2,
  AccountsReceivable = 3,
  CropInventory = 4,
  GrowingCrops = 5,
  BreedingStock = 6,
  MarketLivestockOrPoultry = 7,
  SpecialtyLivestockOrPoultry = 8,
  PrepaidExpensesAndSupplies = 9,
  NotesReceivable = 10,
  NotReadilyMarketableBondsAndSecurities = 11,
  BuildingAndImprovements = 12,
  RealEstateLand = 13,
  Personal = 14,
  MachineryAndEquipment = 15,
  FarmVehicles = 16,
  PersonalVehicles = 17,
  Other = 18
}

export enum NAICSGroup {
  CropInventory = 1,
  GrowingCrops = 2,
  BreedingStock = 3,
  MarketLivestockOrPoultry = 4,
  SpecialtyLivestockOrPoultry = 5
}

export enum EquipmentCondition {
  Excellent = 1,
  Good = 2,
  Average = 3,
  Fair = 4,
  Poor = 5
}

export enum YesNoValues {
  Yes = 1,
  No = 2
}

export enum BalanceSheetLiabilityCategories {
  AccountsPayable = 1,
  IncomeTaxesPayable = 2,
  RealEstateTaxesPayable = 3,
  NotesPayable = 4,
  OtherLiabilities = 5
}

export enum NotesPayableLoanPurpose {
  Equipment = 1,
  Operating = 2,
}

export enum IdDocumentSde {
  Front = 1,
  Back = 2
}

export enum Subdomain {
  Admin = 1,
  Dealer = 2
}

export enum LoanTermType {
  Years = 1,
  Months = 2 // We will default and only allow years for now, but we store the amount in months. Eventually we may need to allow them to choose
}

export enum CashFlowSections {
  Introduction = 1,
  Income = 2,
  Expenses = 3,
  NonOperating = 4,
  Capital = 5,
  LoanPayments = 6
}

export enum CashFlowIncomeType {
  CropProduction = 1,
  LivestockAndPoultryRaised = 2,
  LivestockAndPoultryPurchaseSale = 3,
  DairyLivestock = 4,
  MilkProduction = 5,
  LivestockProduct = 6,
  OtherFarmIncome = 7,
  NonFarmIncome = 8,
  CapitalSaleIncome = 9
}

export enum CashFlowLineItemPurchaseSaleType {
  PurchaseAndSale = 1,
  PurchaseOnly = 2,
  SaleOnly = 3
}

export enum OtherFarmIncomeType {
  CustomHireIncome = 1,
  Other = 2
}

export enum NonFarmIncomeType {
  PersonalIncome = 1,
  BusinessIncome = 2,
  Other = 3
}

export enum CapitalSalesIncomeType {
  Equipment = 1,
  RealEstate = 2,
  Other = 3
}

export enum CashFlowExpenseType {
  CarAndTruck = 1,
  Chemicals = 2,
  Conservation = 3,
  CustomHire = 4,
  FeedSupplement = 5,
  FeedGrainAndRoughage = 6,
  FertilizersAndLime = 7,
  FreightAndTrucking = 8,
  GasFuelOil = 9,
  Insurance = 10,
  LaborHired = 11,
  RentMachineryEquipmentVehicles = 12,
  RentLandAnimals = 13,
  RepairsAndMaintenance = 14,
  SeedsAndPlants = 15,
  StorageAndWarehousing = 16,
  Supplies = 17,
  TaxesRealEstate = 18,
  Utilities = 19,
  VeterinaryBreedingMedicine = 20,
  OtherExpenses = 21,
  OtherIrrigation = 22,
  OperatingLoanInterest = 23
}

export enum CashFlowOtherExpenseType {
  Household = 1,
  CapitalPurchases = 2
}